import { asyncRouterMap, constantRouterMap } from '@/router'

/**
 * 通过meta.permissions判断是否与当前用户权限匹配
 * @param permissions
 * @param route
 */
function hasPermission(permissions, route) {

  if (route.meta && route.meta.permissions) {
    return permissions.some(permission => route.meta.permissions.indexOf(permission) >= 0)
  } else {
    return true
  }
}

/**
 * 递归过滤异步路由表，返回符合用户角色权限的路由表
 * @param asyncRouterMap
 * @param permissions
 */
function filterAsyncRouter(asyncRouterMap, permissions) {
  const accessedRouters = asyncRouterMap.filter(route => {
    if (permissions.indexOf('all') >= 0 || hasPermission(permissions, route)) {
      if (route.children && route.children.length) {
        route.children = filterAsyncRouter(route.children, permissions)
      }
      return true
    }
    return false
  })
  return accessedRouters
}

const permissions = {
  state: {
    routers: constantRouterMap,
    addRouters: []
  },
  mutations: {
    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers
      state.routers = constantRouterMap.concat(routers)
    }
  },
  actions: {
    GenerateRoutes({ commit, rootState }, data) {
      return new Promise(resolve => {
        const { permissions } = data
        let accessedRouters = filterAsyncRouter(asyncRouterMap, permissions)
        // enterprise_cash_payment 模式隐藏账户管理模块
        if (rootState.user.cooperation_type === 'enterprise_cash_payment') {
          accessedRouters = accessedRouters.filter(route => route.name !== 'AppClient')
        }
        commit('SET_ROUTERS', accessedRouters)
        resolve()
      })
    }
  }
}

export default permissions
